import '../components/zoomable-image/zoomable-image.js';
import '../components/zoom-layer/zoom-layer.js';
import '../components/ai-badge/ai-badge.js';
import '../components/product-personalization-banner/product-personalization-banner.js';
import '../components/infobox/infobox.js';
import { VSP_OPEN_EVENT } from '../components/vsp-modal/vsp-event.js';

if (
  document.querySelector('ents-online-reservation-link, ents-online-reservation, ents-online-reservation-app-layer')
) {
  import('../components/online-reservation-ssi/online-reservation.js');
  import('../components/online-reservation-ssi/online-reservation-app-layer.js');
  import('../components/online-reservation-link/online-reservation-link.js');
}

if (document.querySelector('ents-vsp-modal')) {
  document.addEventListener(
    VSP_OPEN_EVENT,
    async (event) => {
      await import('../components/vsp-modal/vsp-modal.js');
      await customElements.whenDefined('ents-vsp-modal');
      document.dispatchEvent(new CustomEvent(VSP_OPEN_EVENT, { detail: (event as CustomEvent).detail }));
    },
    { once: true },
  );
}

if (document.querySelector('ents-material-tracking')) {
  import('../components/product-summary/material-tracking.js');
}
